import {texture} from "p3";
import NPC from "./NPC";
import definitions from "../../../definitions";

export default class NPCBatwitch extends NPC {
    constructor() {
        super(definitions.NPC_ID.BATWITCH);

        this.collisionRadius = 20;
        this.collisionOffsetX = 5;
        this.collisionOffsetY = -18;
    }

    init() {
        super.init();

        this.addViewWithTexture(texture("boss_batwitch_idle_00"));

        this.addShadow(definitions.SHADOW_SIZE.LARGE, 1, new PIXI.Point(0, 0));
        this.animateIdle(1);
    }

    onViewAdded() {
        super.onViewAdded();
    }
}